import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';

import css from './SectionPricing.module.css';
import { H2, H3 } from '../../Primitives/Heading';
import { P } from '../../Primitives/P';

const SectionPricing = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const primaryCtaData = {
    fieldType: 'internalButtonLink',
    href: '/s',
    content: 'Jetzt starten',
  };

  const secondaryCtaData = {
    fieldType: 'internalButtonLink',
    href: '/test',
    content: 'ADHS-Schnelltest',
  };

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className, css.pricingContainer)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <H2 className={css.title}>Was kostet Nachhilfe bei Lernweise?</H2>
              <P className={css.description}>
                Ab <span className={css.highlight}>€30</span> pro Einheit (45 min.) Der genaue Preis
                hängt von der Laufzeit der Nachhilfe ab.
              </P>
              <H3 className={css.subheading}>Immer inklusive:</H3>
              <ul className={css.benefits}>
                <li>Geld-zurück-Garantie im ersten Monat</li>
                <li>
                  Volle Flexibilität (Fachwechsel, Terminänderungen, Wechsel des Nachhilfelehrers)
                </li>
              </ul>
            </header>
          ) : null}

          <div className={css.reviewWrapper}></div>
        </div>

        <div className={css.right}>
          <div className={css.block}>
            <div className={css.blockTitle}>
              {intl.formatMessage({ id: 'LandingPage.SectionPricing.tutoringCost' })}
            </div>
            <div className={css.blockDescription}>
              {intl.formatMessage({ id: 'LandingPage.SectionPricing.tutoringCostDescription' })}
            </div>
            <div className={css.ctaContainer}>
              <Field
                data={primaryCtaData}
                className={classNames(defaultClasses.ctaButton, css.ctaButton)}
                options={fieldOptions}
              />
              <Field
                data={secondaryCtaData}
                className={classNames(defaultClasses.ctaButton, css.ctaButton, css.secondaryCta)}
                options={fieldOptions}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionPricing.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionPricing.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionPricing;
